import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { getClassName } from "../../../components/Converter";
import KiloNewton from "../../../components/Math/Units/Metric/KiloNewton";
import AlertBox from "../../../components/Messages";
import { NumberFormatText } from "../../../components/NumberFormatText";
import { RowBody } from "../../../components/RowValue/RowBody";
import { MAX_BEMESSUNGSLAST } from "../../../constants.js";
import { decimalSeparator, thousandSeparator } from "../../../i18n";
import { selectBemessungslast, setBemessungslast } from "../../../store/slices/bemessungslastSlice";
import { selectFrontendZustand } from "../../../store/slices/frontendZustandSlice";

function DesignLoad({ readOnly }) {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const bemessungslast = useSelector(selectBemessungslast);
  const { angepassteBemessungslast: angepassteBemessungslastCheckbox } =
    useSelector(selectFrontendZustand);

  const FdFormula = `\\displaystyle F_{d} = \\gamma_{_{\\small{G}}} \\cdot E_{_{\\small{k,G}}} + \\gamma_{_{\\small{Q}}} \\cdot E_{_{\\small{k,Q}}} +\\gamma_{_{\\small{G,E0}}} \\cdot E_{_{\\small{k,E0}}} - \\gamma_{_{\\small{G,inf}}} \\cdot E_{_{\\\small{k,G,inf}}} `;

  function isWritable() {
    return (
      <NumberFormat
        //fixedDecimalScale={true}
        data-testid="input-design-load"
        decimalScale={2}
        readOnly={angepassteBemessungslastCheckbox}
        className={getClassName(bemessungslast)}
        value={bemessungslast}
        decimalSeparator={decimalSeparator()}
        thousandSeparator={thousandSeparator()}
        displayType="input"
        type="text"
        onValueChange={(value) => {
          dispatch(
            setBemessungslast(value.floatValue === undefined ? Number.NaN : value.floatValue)
          );
        }}
        allowNegative={true}
      />
    );
  }

  function isStatic() {
    return (
      <span className="input">
        <NumberFormatText value={bemessungslast} />
      </span>
    );
  }

  function renderInput() {
    return readOnly ? isStatic() : isWritable();
  }

  return (
    <>
      <RowBody
        titleValue={<p>{t("inner.fdCalculation.designLoad")}</p>}
        indicesValue={
          <span>
            F<sub>d</sub>
          </span>
        }
        inputValue={renderInput()}
        unitValue={<KiloNewton />}
      />
      <Col md={8}>
        <AlertBox
          show={bemessungslast >= MAX_BEMESSUNGSLAST}
          message={t("inner.fdCalculation.errorText.designloadToBig", {
            value: MAX_BEMESSUNGSLAST,
          })}
        />
      </Col>
    </>
  );
}

export default DesignLoad;
